module.exports = __webpack_public_path__ + "static/img/demo_01.b822157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upsell/demo_01.png
// module id = 2KQZ
// module chunks = 134